<script lang="ts">
    
    import { createEventDispatcher } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import type { Game } from "../../Model/Game";
    import { currentTarget, setCheckpointAsTarget } from '../../Services/game';
    import IconCheck from './IconCheck.svelte';
    import IconClose from './IconClose.svelte';
    import IconTargets from './IconTargets.svelte';
    import IsTarget from './IsTarget.svelte';
    
    export let game: Game;

    const targets = game.targets;
    const completed = game.completed;
    const dispatch = createEventDispatcher();

    function onClose(): void {
        dispatch('close');
    }

</script>

<div class="targets-modal" transition:fade>
    <div class="dialog" transition:fly={{ y: 50 }}>
        <div class="header">
            <IconTargets />
            <button type="button" class="close-btn" on:click={onClose}>
                <IconClose size={25} color="#000" />
            </button>
        </div>
        <div class="items">
            <div class="targets">
                {#each $targets as target}
                    <div class="checkpoint" on:click={() => setCheckpointAsTarget(target)}>
                        <div class="image">
                            <img src={target.marker.image} alt="">
                        </div>
                        <div class="detail">
                            <div class="clue">{target.clue || target.name}</div>
                        </div>
                        <div class="state">
                            {#if $currentTarget?.checkpointId === target.id}
                                <IsTarget />
                            {/if}
                        </div>
                    </div>
                {/each}
            </div>

            <div class="completed">
                {#each $completed as checkpoint}
                    <div class="checkpoint">
                        <div class="image">
                            <img src={checkpoint.marker.image} alt="">
                        </div>
                        <div class="detail">
                            <div class="clue">{checkpoint.clue || checkpoint.name}</div>
                        </div>
                        <div class="state">
                            <IconCheck />
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style lang="scss">

    .targets-modal {
        position: absolute;
        z-index: 8000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 10px 10px 95px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.6);
    }

    .dialog {
        width: 100%;
        height: 100%;
        max-width: 400px;
        max-height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    .header {
        position: relative;
        padding: 20px 10px;
        display: flex;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .close-btn {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
        border: none;
        cursor: pointer;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .items {
        flex: 1 1 0;
        padding: 10px;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow: auto;
    }

    .checkpoint {
        padding: 10px 5px;
        border-radius: 4px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 5px;
        
        & + .checkpoint {
            border-top: 1px dashed #ccc;
        }
    }

    .image {
        width: 50px;
        height: 50px;
        flex-shrink: 0;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            transform: scaleX(-1);
        }
    }

    .detail {
        flex: 1 1 0;
        min-width: 0;
    }

    .state {
        width: 40px;
    }

    .clue {
        font-style: italic;
    }

    .completed {
        margin-top: 25px;
        padding-top: 25px;
        border-top: 1px solid #B3B3B3;

        .clue {
            text-decoration: line-through;
        }

    }

</style>
